import { render, staticRenderFns } from "./contentCardBaseD.vue?vue&type=template&id=f0b7b6ae&scoped=true"
import script from "./contentCardBaseD.vue?vue&type=script&lang=js"
export * from "./contentCardBaseD.vue?vue&type=script&lang=js"
import style0 from "./contentCardBaseD.vue?vue&type=style&index=0&id=f0b7b6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b7b6ae",
  null
  
)

export default component.exports